import { Component, input } from '@angular/core';
import { KENDO_SVGICON } from '@progress/kendo-angular-icons';
import { KENDO_CARD, KENDO_STACKLAYOUT } from '@progress/kendo-angular-layout';
import { IconName } from '@unity/services/icon.service';
import { IconSharedComponent } from '@unity/shared/presentation/icon-shared/icon-shared.component';

@Component({
  selector: 'unity-banner-alert-shared',
  standalone: true,
  imports: [KENDO_CARD, KENDO_SVGICON, KENDO_STACKLAYOUT, IconSharedComponent],
  templateUrl: './banner-alert-shared.component.html',
  styleUrl: './banner-alert-shared.component.scss',
})
export class BannerAlertSharedComponent {
  public readonly $icon = input.required<IconName>({ alias: 'icon' });
}
